import React, { useEffect } from 'react'
import { Icon, l } from '@manychat/manyui'

import { KnowledgeActionCards } from 'apps/aiAutomation/components/KnowledgeActionCards'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { useOpenKnowledgeEditor } from 'apps/aiAutomation/lib/hooks/useOpenKnowledgeEditor'

import cm from './styles.module.css'

export const EmptyKnowledge = () => {
  const { openNew } = useOpenKnowledgeEditor()

  useEffect(() => {
    AiAutomationAnalytics.logAutomationEmptyStateOpened({ type: 'instant_answers' })
  }, [])

  return (
    <section className={cm.wrapper}>
      <SidebarHeader />

      <div className={cm.content}>
        <div className={cm.content__description}>
          <Icon.Faq size={32} />

          <h2 className="m-t-sm text-subheading">{l.translate('Set up AI Replies')}</h2>

          <p className="m-t-xs">
            {l.translate('Give AI the info it needs to deliver the best answers')}
          </p>
        </div>

        <KnowledgeActionCards onSelect={(type) => openNew(type, 'automation_empty_state')} />
      </div>
    </section>
  )
}
